import { render, staticRenderFns } from "./SparepartType.vue?vue&type=template&id=b1c6d528&scoped=true&"
import script from "./SparepartType.vue?vue&type=script&lang=js&"
export * from "./SparepartType.vue?vue&type=script&lang=js&"
import style0 from "./SparepartType.vue?vue&type=style&index=0&id=b1c6d528&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c6d528",
  null
  
)

export default component.exports